module.exports = __webpack_public_path__ + "static/monodrone-0148ed1ab034285ee748a2ed2942b79a.jpeg";